import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const NewsListPage = lazy(() =>
  import('./pages/NewsListPage').then((module) => ({
    default: module.NewsListPage,
  })),
);

const NewsDetailPage = lazy(() =>
  import('./pages/NewsDetailPage').then((module) => ({
    default: module.NewsDetailPage,
  })),
);

const ManageNewsPage = lazy(() =>
  import('./pages/ManageNewsPage').then((module) => ({
    default: module.ManageNewsPage,
  })),
);

export const newsRoutes: RouteObject[] = [
  {
    path: 'novedades',
    element: createElement(ProtectedRoute, { view: 'news' }),
    children: [
      { index: true, element: createElement(NewsListPage) },
      { path: ':id', element: createElement(NewsDetailPage) },
    ],
  },
  {
    path: 'novedades/gestion',
    element: createElement(ProtectedRoute, { view: 'newsAdmin' }),
    children: [{ index: true, element: createElement(ManageNewsPage) }],
  },
];
